var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.$store.getters.bookings).length)?_c('div',{key:_vm.$store.getters.bookingCalendarHash},[_c('transition',{attrs:{"name":"flixFadeIn"}},[_c('div',{key:_vm.date + _vm.$store.getters.calendarDate.getTime()},[(!_vm.date)?_c('calendarView',{attrs:{"callback":(settings) => {
            _vm.setDate(settings)
          }}}):_vm._e(),(_vm.date)?_c('detailView',{attrs:{"date":_vm.$store.getters.calendarDate,"callback":(settings) => {
            _vm.setDate(settings)
          }}}):_vm._e()],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }